import { render, staticRenderFns } from "./CreateUP.vue?vue&type=template&id=11afadfb"
import script from "./CreateUP.vue?vue&type=script&lang=js"
export * from "./CreateUP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports